import React, { useContext, useEffect, useRef, useState } from "react";
import { StoreContext } from "../context";
import { Link } from "react-router-dom";

import { Breadcrumbs, Counter } from "../components";
import { useRecoilState } from "recoil";

import { Message } from "primereact/message";
import cartEmpty from "../assets/illustrations/cartEmpty.svg";
import { useTranslation } from "react-i18next";

import swalWithBootstrapButtons from "sweetalert2";
import Swal from "sweetalert2";
import { Simulator } from "../constant";
import {
  age,
  DurationCredit,
  Salary,
  simulatorState,
  modalState,
  PremiumClient,
} from "../states/atoms/simulator";

import dayjs from "dayjs";
import animationData from "../assets/lottie/95088-success.json";

import ReactGA from "react-ga4";

export default function Cart() {
  ReactGA.send({
    hitType: "pageview",
    page: "/cart",
    title: "BEA | Cart",
  });

  const { cart, setCart } = useContext(StoreContext);
  const [showModal, setShowModal] = useRecoilState(modalState);
  const [simulatorStateRecoil, setSimulatorStateRecoil] =
    useRecoilState(simulatorState);
  const [resultCart, setResultCart] = useState(null);
  const [dateValue, setDateValue] = useState(dayjs("2000-08-18T21:11:54"));
  const result = useRef(0);

  const handleChange = (newValue) => {
    setDateValue(newValue);
  };

  //todo: Simulator Values
  const toast = useRef(null);

  //todo:simulator state "recoil"
  const [durationSimulator, setDurationSimulator] =
    useRecoilState(DurationCredit);
  const [ageSimulator, setAgeSimulator] = useRecoilState(age);
  const [isPremiumClient, setISPremiumClient] = useRecoilState(PremiumClient);
  const [salarySimulator, setSalarySimulator] = useRecoilState(Salary);

  useEffect(() => {
    let totalPanier = getSubtotal();
    
    if (true) {
      // console.log("========================");
      // // console.log("ageSimulator", ageSimulator);
      // // console.log("salarySimulator", salarySimulator);
      // // console.log("totalPanier", totalPanier);
      // // console.log("durationSimulator", durationSimulator);
      // console.log("isPremiumClient", isPremiumClient);
      // console.log("========================");
      result.current = Simulator(
        ageSimulator,
        salarySimulator,
        totalPanier,
        durationSimulator,
        isPremiumClient
      );
      setResultCart(result.current);
    }
  }, [simulatorState]);

  // eslint-disable-next-line
  const { t, i18n } = useTranslation();

  const handleAmountChange = (value, max, index) => {
    if (value <= 0 || value > max || !cart[index]) return;
    setCart((cart) => {
      cart[index].amount = value;
      return [...cart];
    });
  };

  const handleDeleteItem = (index) => {
    if (!cart[index]) return;
    setCart((cart) => cart.filter((_, i) => i !== index));
  };

  const handleClearCart = () => {
    if (i18n.language === "fr") {
      swalWithBootstrapButtons
        .fire({
          title: "Vider Le Panier",
          text: "Voullez vous vraiment vider le panier?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "rgba(252,34,34,0.71)",
          confirmButtonText: "Vider",
          cancelButtonText: "Annuler",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            Swal.fire("vidée!", "Votre panier a été vidée.", "success");
            return setCart([]);
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            return Swal.DismissReason.cancel;
          }
        });
    } else {
      swalWithBootstrapButtons
        .fire({
          title: "إفراغ عربة التسوق",
          text: "أنت على وشك إفراغ عربة التسوق. هل أنت موافق؟",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "rgba(252,34,34,0.71)",
          confirmButtonText: "إفراغ",
          cancelButtonText: "إلغاء",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            Swal.fire("!أفرغت", "لقد تم إفراغ سلتك", "success");
            return setCart([]);
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            return Swal.DismissReason.cancel;
          }
        });
    }
  };

  const getSubtotal = () => {
    var total = cart.reduce((total, item) => {
      total += item?.variantes[item.colorIndex]?.price * item.amount;
      // todo:atoms for sum of prices
      // return total.hamishEldjedia+total.total;
      return total;
    }, 0);

    // console.log("getSubtotal - isPremiumClient:", isPremiumClient, "total:", total);
    var result = Simulator(
      ageSimulator,
      salarySimulator,
      total,
      durationSimulator,
      isPremiumClient
    );
    // console.log(parseInt(result.hamishEldjedia) + parseInt(result.total));
    var resultSum =
      parseInt(result.hamishEldjedia) +
      parseInt(result.total) +
      parseInt(result.CE) +
      parseInt(result.CAAT) +
      parseInt(result.tala);
    return resultSum;
  };
  const gethamish = () => {
    var total = cart.reduce((total, item) => {
      total += item?.variantes[item.colorIndex]?.price * item.amount;
      // todo:atoms for sum of prices
      // return total.hamishEldjedia+total.total;
      return total;
    }, 0);

    var result = Simulator(
      ageSimulator,
      salarySimulator,
      total,
      durationSimulator,
      isPremiumClient
    );
    // console.log(parseInt(result.hamishEldjedia) + parseInt(result.total));
    var resultSum = parseInt(result.hamishEldjedia);
    return resultSum;
  };

  const getCE = () => {
    var total = cart.reduce((total, item) => {
      total += item?.variantes[item.colorIndex]?.price * item.amount;
      // todo:atoms for sum of prices
      // return total.hamishEldjedia+total.total;
      return total;
    }, 0);

    var result = Simulator(
      ageSimulator,
      salarySimulator,
      total,
      durationSimulator,
      isPremiumClient
    );
    // console.log(parseInt(result.hamishEldjedia) + parseInt(result.total));
    var resultSum = parseInt(result.CE);
    return resultSum;
  };
  const getECH = () => {
    var total = cart.reduce((total, item) => {
      
      total += item?.variantes[item.colorIndex]?.price * item.amount;
      // todo:atoms for sum of prices
      // return total.hamishEldjedia+total.total;
      return total;
    }, 0);

    var result = Simulator(
      ageSimulator,
      salarySimulator,
      total,
      durationSimulator,
      isPremiumClient
    );
    console.log(result.versement);
    var resultSum = parseInt(result.versement[0].echp);
    return resultSum;
  };
  const getTALA = () => {
    var total = cart.reduce((total, item) => {
      total += item?.variantes[item.colorIndex]?.price * item.amount;
      // todo:atoms for sum of prices
      // return total.hamishEldjedia+total.total;
      return total;
    }, 0);

    var result = Simulator(
      ageSimulator,
      salarySimulator,
      total,
      durationSimulator,
      isPremiumClient
    );
    // console.log(parseInt(result.hamishEldjedia) + parseInt(result.total));
    var resultSum = parseInt(result.tala);
    return resultSum;
  };
  const getPanier = () => {
    var total = cart.reduce((total, item) => {
      total += item?.variantes[item.colorIndex]?.price * item.amount;
      // todo:atoms for sum of prices
      // return total.hamishEldjedia+total.total;
      return total;
    }, 0);

    return total;
  };
  const getCAAT = () => {
    var total = cart.reduce((total, item) => {
      total += item?.variantes[item.colorIndex]?.price * item.amount;
      // todo:atoms for sum of prices
      // return total.hamishEldjedia+total.total;
      return total;
    }, 0);

    var result = Simulator(
      ageSimulator,
      salarySimulator,
      total,
      durationSimulator,
      isPremiumClient
    );
    // console.log(parseInt(result.hamishEldjedia) + parseInt(result.total));
    var resultSum = parseInt(result.CAAT);
    return resultSum;
  };


  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  return (
    <>
      {cart.length > 0 ? (
        <>
          {i18n.language === "fr" ? (
            <Breadcrumbs>
              <Link to="/">{t("navbar.home")}</Link>
              <span>{t("navbar.cart")}</span>
            </Breadcrumbs>
          ) : (
            <Breadcrumbs>
              <span>{t("navbar.cart")}</span>
              <Link to="/">{t("navbar.home")}</Link>
            </Breadcrumbs>
          )}

          <section className="py-12">
            {i18n.language === "fr" ? (
              <div className="tw-container">
                <article className="hidden lg:block py-10">
                  <div
                    className="grid text-center"
                    style={{ gridTemplateColumns: "1fr 1fr 1fr 1fr auto" }}
                  >
                    <h5>{t("panier.table.product")}</h5>
                    <h5>{t("panier.table.designation")}</h5>
                    <h5>{t("panier.table.unitPrice")}</h5>
                    <h5>{t("panier.table.quantity")}</h5>
                    <h5></h5>
                    <span className="w-8 h-8"></span>
                  </div>
                  <hr className="mt-6" />
                </article>
                {cart.map((item, i) => {
                  const {
                    name,
                    description,
                    variantes,
                    colorIndex,
                    amount,
                    image,
                    color,
                    max,
                  } = item;

                  let price = null;
                  if (colorIndex && item?.variantes?.length > colorIndex) {
                    price = item?.variantes[colorIndex]?.price;
                  } else if (item?.variantes?.length > 0) {
                    price = item?.variantes[0]?.price;
                  }
                  if (price === undefined || price === null) {
                    localStorage.clear();
                  }

                  return (
                    <article
                      key={i}
                      className="grid cart-grid-cols-3 lg:cart-grid-cols-5 place-items-center mb-6 capitalize"
                    >
                      <div className="flex w-full gap-2 md:gap-4 items-center">
                        <img
                          alt={name}
                          className="object-cover w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 rounded-md"
                          src={image}
                        />
                        <div>
                          <h5 className="text-base md:text-lg lg:text-xl font-semibold">
                            {item?.variantes[colorIndex]?.reference}
                          </h5>
                          <div className="flex items-center gap-2 text-sm lg:text-base">
                            {t("panier.color")}:{" "}
                            <div
                              style={{
                                background: item?.variantes[colorIndex]?.color,
                                border: `1.5px solid #000000`,
                                boxShadow: `0 0 0 2px #fff, 0 0 0 4px #000000 33`,
                              }}
                              className="w-3 h-3 lg:w-4 lg:h-4 rounded"
                            />
                          </div>
                        </div>
                      </div>
                      <h5 className="hidden lg:block">{name}</h5>
                      <h5 className="hidden lg:block">
                        {numberWithCommas(price) + `.00 Da`}
                      </h5>
                      <Counter
                        className="text-3xl md:text-4xl"
                        count={amount}
                        setCount={(value) => handleAmountChange(value, max, i)}
                        maxNum={max}
                      />
                      {/*<h5 className="hidden lg:block">{(amount * price).toLocaleString("fr-FR")}</h5>*/}
                      <button
                        className="block ml-3 md:ml-0 w-7 h-7 p-2 bg-red-600 text-white rounded transition hover:bg-red-700 hover:shadow-lg"
                        onClick={() => handleDeleteItem(i)}
                      >
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          strokeWidth="0"
                          viewBox="0 0 448 512"
                        >
                          <path d="M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"></path>
                        </svg>
                      </button>
                    </article>
                  );
                })}
                <hr className="mt-10" />
                <div className="flex gap-4 sm:gap-0 justify-between py-8 ">
                  <Link
                    to="/products"
                    className="btn-xs bg-primary-color hover:bg-secondary-color transition rounded-lg px-2 sm:px-4 text-white text-bold"
                  >
                    {t("panier.continue")}
                  </Link>
                  <button
                    onClick={handleClearCart}
                    className="btn-xs font-bold text-red-900 bg-red-300 transition hover:text-red-300 hover:bg-red-900 rounded-lg px-2 sm:px-4"
                  >
                    {t("panier.clear")}
                  </button>
                </div>
                <section className="flex justify-center lg:justify-end">
                  <div className="w-full md:w-auto">
                    <article className={`md:border px-4 py-2 md:px-12 md:py-6 ${isPremiumClient ? "bg-yellow-50 border-yellow-300 shadow-lg" : ""}`}>
                      {/*todo: panier */}
                      <h6
                        className="grid text-sm md:text-xl font-bold"
                        style={{ gridTemplateColumns: "200px 1fr" }}
                      >
                        {t("panier.panier")}:
                        <span className={"text-right font-bold"}>
                          {numberWithCommas(getPanier())}.00 Dzd
                        </span>
                      </h6>
                      {/*todo: montant du financement */}
                      <h6
                        className="grid text-sm md:text-lg"
                        style={{ gridTemplateColumns: "200px 1fr" }}
                      >
                        {t("panier.financement")}:
                        <span className={"text-right"}>
                          {numberWithCommas(getCE())}.00 Dzd
                        </span>
                      </h6>
                      {/*todo: hamish */}
                      <h6
                        className="grid text-sm md:text-lg"
                        style={{ gridTemplateColumns: "200px 1fr" }}
                      >
                        {t("panier.hamish")}:
                        <span className={"text-right"}>
                          {numberWithCommas(gethamish())}.00 Dzd
                        </span>
                      </h6>

                      {/*todo: tala */}
                      <h6
                        className="grid"
                        style={{ gridTemplateColumns: "200px 1fr" }}
                      >
                        {t("panier.takaful")}:
                        <span className={"text-right"}>
                          {numberWithCommas(getTALA())},00 Dzd
                        </span>
                      </h6>
                      {/*todo: CAAT */}
                      {/* <h6
                        className="grid"
                        style={{ gridTemplateColumns: "200px 1fr" }}
                      >
                        {t("panier.caat")}:
                        <span className={"text-right"}>
                          {numberWithCommas(getCAAT())},00 Dzd{" "}
                        </span>
                      </h6> */}
                      {/*todo: Échéanciers */}
                      <h6
                        className="grid text-sm md:text-lg"
                        style={{ gridTemplateColumns: "200px 1fr" }}
                      >
                        {t("panier.schedule")}:
                        <span className={"text-right"}>
                          {numberWithCommas(getECH())}.00 Dzd Pendant{" "}
                          {durationSimulator} Mois
                        </span>
                      </h6>
                      {isPremiumClient && (
                        <div className="mt-4 flex items-center gap-2">
                          <svg className="w-5 h-5 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M10 15l-5.878 3.09 1.122-6.545L.488 6.91l6.561-.955L10 0l2.951 5.955 6.561.955-4.756 4.635 1.122 6.545z"/>
                          </svg>
                          <span className="text-yellow-700 font-semibold">
                            {i18n.language === "fr" ? "Client Premium: Aucune avance exigée !" : "عميل متميز: لا يوجد هامش جدية"}
                          </span>
                        </div>
                      )}
                    </article>

                    {getPanier() < 1500000 && getECH() > 5000 ? (
                      simulatorStateRecoil ? (
                        <Link
                          to="/checkout"
                          className="mt-4 text-center btn w-full bg-yellow-600 transition hover:shadow-lg hover:bg-yellow-500 text-blue-50 font-semibold"
                        >
                          {t("panier.create")}{getECH()}
                        </Link>
                      ) : (
                        <>
                          <span
                            className="mt-4 text-center btn w-full bg-yellow-600 transition hover:shadow-lg hover:bg-yellow-500 text-blue-50 font-semibold"
                            onClick={() => setShowModal(true)}
                          >
                            {t("panier.create")}
                          </span>
                        </>
                      )
                    ) : (
                      <div className="w-full mt-4">
                        <Message
                          className="w-full mt-4"
                          severity="warn"
                          text="Vous ne pouvez pas dépasser un montant total de 1 500 000,00 DZD, et l’échéance mensuelle doit être supérieure à 5 000,00 DZD."
                        />
                      </div>
                    )}
                  </div>
                </section>
              </div>
            ) : (
              <div className="tw-container">
                <article className="hidden lg:block py-10">
                  <div
                    className="grid text-center"
                    style={{ gridTemplateColumns: "auto 1fr 1fr 1fr 1fr" }}
                  >
                    {/*<span className="w-8 h-8"></span>*/}
                    <h5></h5>
                    <h5>{t("panier.table.quantity")}</h5>
                    <h5>{t("panier.table.unitPrice")}</h5>
                    <h5>{t("panier.table.designation")}</h5>
                    <h5>{t("panier.table.product")}</h5>
                  </div>
                  <hr className="mt-6" />
                </article>
                {cart.map((item, i) => {
                  const {
                    name,
                    description,
                    variantes,
                    colorIndex,
                    amount,
                    image,
                    color,
                    max,
                  } = item;

                  let price = null;
                  if (colorIndex && item?.variantes?.length > colorIndex) {
                    price = item?.variantes[colorIndex]?.price;
                  } else if (item?.variantes?.length > 0) {
                    price = item?.variantes[0]?.price;
                  }
                  if (price === undefined || price === null) {
                    localStorage.clear();
                  }

                  return (
                    <article
                      key={i}
                      className="grid cart-grid-cols-3-ar lg:cart-grid-cols-5-ar place-items-center mb-6 capitalize"
                    >
                      <button
                        className="block mr-3 md:mr-0 w-7 h-7 p-2 bg-red-600 text-white rounded transition hover:bg-red-700 hover:shadow-lg"
                        onClick={() => handleDeleteItem(i)}
                      >
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          strokeWidth="0"
                          viewBox="0 0 448 512"
                        >
                          <path d="M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"></path>
                        </svg>
                      </button>

                      <Counter
                        className="text-3xl md:text-4xl"
                        count={amount}
                        setCount={(value) => handleAmountChange(value, max, i)}
                        maxNum={max}
                      />
                      <h5 className="hidden lg:block">
                        {numberWithCommas(price)}.00 دج
                      </h5>
                      <h5 className="hidden lg:block">
                        {variantes[0].namear.length < 2
                          ? name
                          : variantes[0].namear}
                      </h5>
                      <div className="flex w-full gap-2 md:gap-4 items-center justify-end">
                        <div>
                          <h5 className="text-base md:text-lg lg:text-xl font-semibold">
                            {item?.variantes[colorIndex]?.reference}
                          </h5>
                          <div className="flex items-center gap-2 text-sm lg:text-base flex-row-reverse">
                            :{t("panier.color")}
                            <div
                              style={{
                                background: item?.variantes[colorIndex]?.color,
                              }}
                              className="w-3 h-3 lg:w-4 lg:h-4 rounded"
                            />
                          </div>
                        </div>
                        <img
                          alt={name}
                          className="object-cover w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 rounded-md"
                          src={image}
                        />
                      </div>
                    </article>
                  );
                })}
                <hr className="mt-10" />
                <div className="flex justify-between py-8">
                  <button
                    onClick={handleClearCart}
                    className="btn-sm font-bold text-red-900 bg-red-300 transition hover:bg-red-900 hover:text-red-400"
                  >
                    {t("panier.clear")}
                  </button>
                  <Link
                    to="/products"
                    className="btn-sm w-max bg-primary-color text-white text-bold transition hover:bg-secondary-color"
                  >
                    {t("panier.continue")}
                  </Link>
                </div>
                <section className="flex justify-center lg:justify-start">
                  <div className="w-full md:w-auto">
                    <article className="md:border px-4 py-2 md:px-12 md:py-6">
                      {/*todo: panier */}
                      <h6
                        className="grid text-xl font-bold text-right "
                        style={{ gridTemplateColumns: "200px 1fr" }}
                      >
                        <span className={"text-left font-bold"}>
                          {numberWithCommas(getPanier())}.00 دج
                        </span>
                        :{t("panier.panier")}
                      </h6>
                      {/*todo: montant du financement */}
                      <h6
                        className="grid text-right"
                        style={{ gridTemplateColumns: "200px 1fr" }}
                      >
                        <span className={"text-left"}>
                          {numberWithCommas(getCE())}.00 دج
                        </span>
                        :{t("panier.financement")}
                      </h6>
                      {/*todo: hamish */}
                      <h6
                        className="grid text-right"
                        style={{ gridTemplateColumns: "200px 1fr" }}
                      >
                        <span className={"text-left"}>
                          {numberWithCommas(gethamish())}.00 دج
                        </span>
                        :{t("panier.hamish")}
                      </h6>

                      {/*todo: tala */}
                      <h6
                        className="grid text-right"
                        style={{ gridTemplateColumns: "200px 1fr" }}
                      >
                        <span className={"text-left"}>
                          {numberWithCommas(getTALA())}.00 دج
                        </span>
                        :{t("panier.takaful")}
                      </h6>

                      {/*todo: CAAT */}
                      {/* <h6
                        className="grid text-right"
                        style={{ gridTemplateColumns: "200px 1fr" }}
                      >
                        <span className={"text-left"}>
                          {numberWithCommas(getCAAT())}.00 دج
                        </span>
                        :{t("panier.caat")}
                      </h6> */}

                      {/*todo: Échéanciers */}
                      
                      <h6
                        className="grid text-right"
                        style={{ gridTemplateColumns: "200px 1fr" }}
                      >
                        <span className={"text-left"}>
                          {" "}
                          دج{numberWithCommas(getECH())}.00 للشهر مدة{" "}
                          {durationSimulator} شهرا{" "}
                        </span>
                        :{t("panier.schedule")}
                      </h6>
                    </article>
                    { getPanier() < 15000000 && getECH() > 5000 ? (
                      simulatorStateRecoil ? (
                        <Link
                          to="/checkout"
                          className="mt-4 text-center btn w-full bg-yellow-600 transition hover:shadow-lg hover:bg-yellow-500 text-blue-50 font-semibold"
                        >
                          {t("panier.create")}
                        </Link>
                      ) : (
                        <>
                          <span
                            className="mt-4 text-center btn w-full bg-yellow-600 transition hover:shadow-lg hover:bg-yellow-500 text-blue-50 font-semibold"
                            onClick={() => setShowModal(true)}
                          >
                            {t("panier.create")}
                          </span>
                        </>
                      )
                    ) : (
                      <div className="w-full mt-4">
                        <Message
                          className="w-full mt-4"
                          severity="warn"
                          text="لا يمكن أن يتجاوز المبلغ الإجمالي 1,500,000.00 دج، ويجب أن تكون خطة الدفع الشهرية أكبر من 5,000.00 دج شهريًا"
                        />
                      </div>
                    )}
                  </div>
                </section>
              </div>
            )}
          </section>
        </>
      ) : (
        <div className="grid place-items-center text-center pt-10 mt-10 mb-10">
          <h2 className="font-bold">{t("panier.msgempty")}</h2>

          <img className="w-1/3" src={cartEmpty} />

          <Link
            to="/products"
            className="mt-5 btn-sm w-max mx-auto bg-primary-color text-secondary-color"
          >
            {t("panier.btnempty")}
          </Link>
        </div>
      )}
    </>
  );
}
